// prettier-ignore
// Auto-generated by yarn supported-browsers
 export default /Edge?\/(9[89]|\d{3,})(\.\d+|)(\.\d+|)|Firefox\/(9[7-9]|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(9[89]|\d{3,})\.\d+(\.\d+|)|Maci.* Version\/(16\.\d+|(1[7-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( Mobile\/\w+|) Safari\//;
